document.addEventListener("DOMContentLoaded", function () {
  console.log("Carousel script loaded");

  const carousels = document.querySelectorAll(".fcp-carousel");
  console.log("Found carousels:", carousels.length);

  carousels.forEach(function (carousel, index) {
    console.log(`Init carousel #${index}`);

    const viewport = carousel.querySelector(".fcp-carousel-viewport");
    const track = carousel.querySelector(".fcp-carousel-track");
    const items = carousel.querySelectorAll(".fcp-carousel-item");
    const prevBtn = carousel.querySelector(".fcp-nav-btn--prev");
    const nextBtn = carousel.querySelector(".fcp-nav-btn--next");
    const pageIndicators = carousel.querySelector(".fcp-page-indicators");

    if (!track || !prevBtn || !nextBtn || !viewport || items.length === 0) {
      console.warn("Missing elements in carousel #", index);
      return;
    }

    // Calculate items per page based on viewport width
    function getItemsPerPage() {
      const viewportWidth = viewport.offsetWidth;
      const itemWidth = items[0].offsetWidth;
      const gap = 16; // gap between items
      return Math.floor((viewportWidth + gap) / (itemWidth + gap));
    }

    let currentPage = 0;
    let itemsPerPage = getItemsPerPage();
    const totalPages = Math.ceil(items.length / itemsPerPage);

    // Create page indicator buttons
    function createPageIndicators() {
      pageIndicators.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const btn = document.createElement('button');
        btn.className = 'fcp-page-btn';
        btn.setAttribute('aria-label', `Go to page ${i + 1}`);
        btn.addEventListener('click', () => goToPage(i));
        pageIndicators.appendChild(btn);
      }
    }

    // Update active page indicator and button states
    function updateNavigation() {
      const pageButtons = pageIndicators.querySelectorAll('.fcp-page-btn');
      pageButtons.forEach((btn, i) => {
        btn.classList.toggle('active', i === currentPage);
      });

      prevBtn.disabled = currentPage === 0;
      nextBtn.disabled = currentPage === totalPages - 1;
    }

    // Go to specific page
    function goToPage(page) {
      if (page < 0 || page >= totalPages) return;
      
      currentPage = page;
      const scrollAmount = currentPage * itemsPerPage * (items[0].offsetWidth + 16);
      
      track.style.transform = `translateX(-${scrollAmount}px)`;
      updateNavigation();
      
      console.log(`Carousel #${index} page ${currentPage + 1}/${totalPages}`);
    }

    // Navigation event listeners
    prevBtn.addEventListener("click", function () {
      goToPage(currentPage - 1);
    });

    nextBtn.addEventListener("click", function () {
      goToPage(currentPage + 1);
    });

    // Handle window resize
    window.addEventListener('resize', function() {
      const newItemsPerPage = getItemsPerPage();
      if (newItemsPerPage !== itemsPerPage) {
        itemsPerPage = newItemsPerPage;
        const newTotalPages = Math.ceil(items.length / itemsPerPage);
        
        // Adjust current page if needed
        if (currentPage >= newTotalPages) {
          currentPage = Math.max(0, newTotalPages - 1);
        }
        
        createPageIndicators();
        goToPage(currentPage);
      }
    });

    // Initialize
    createPageIndicators();
    updateNavigation();
    
    // Add smooth transition to track
    track.style.transition = 'transform 0.3s ease';
  });
});
